(() => {
    const trackSearchRecommendation = (label, searchTerm, searchCategory) => {
        if (window && window.ck && window.ck.tracking && window.ck.tracking.trackEvent) {
            window.ck.tracking.trackEvent({
                type: 'event',
                name: 'searchSubmit',
                label,
                internalSearchPhrase: searchTerm,
                userInput: searchTerm,
                searchCategory
            });
        }
    };

    const searchForm = document.getElementById('recipes-search-form');
    if (searchForm) {
        searchForm.addEventListener('submit', event => {
            const searchInputElement = event.target.elements.Suchbegriff;
            const searchInput = searchInputElement.value;
            const defaultSearchInput = searchInputElement.getAttribute('value');
            const label = searchInput && searchInput !== defaultSearchInput ? 'direct' : 'default';
            trackSearchRecommendation(label, searchInput);
        });
    }

    const tagList = document.querySelectorAll('#recipe-tag-list .sg-pill');
    for (const elem of tagList) {
        const searchTerm = elem.innerText;
        elem.addEventListener('click', () => trackSearchRecommendation('tagcloud_recipe_landingpage', searchTerm, 'recipe'));
    }

    const searchLinks = document.querySelectorAll('[data-tracking-search]');
    for (const elem of searchLinks) {
        try {
            const {label, searchTerm, searchCategory} = JSON.parse(elem.dataset.trackingSearch);
            elem.addEventListener('click', () => trackSearchRecommendation(label, searchTerm, searchCategory))
        }
        catch (e) {
            console.error("Unable add search tracking listenerlabel", elem, e);
        }
    }
})();
